import { DatePicker } from "antd";
import { motion } from "framer-motion";
import Textarea from "../../../../Components/Textarea";
import Input from "../../../../Components/Input";
import dayjs from "dayjs";
import { useCreateDiscountMutation } from "../../../../hooks/DiscountManagement/useCreateDiscountMutation";
import Button from "../../../../Components/Button";
import { formatNumberWithCommas } from "../../../../utils/formatNumber";
import { FormEvent } from "react";

const OrderDiscountForm = ({
  payload,
  setPayload,
  setStartDate,
  startDate,
  endDate,
  setEndDate,
  handleInputChange,
}: any) => {
  const { RangePicker } = DatePicker;
  const { mutateAsync, isPending: isLoading } =
    useCreateDiscountMutation(payload);
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    mutateAsync();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Input
        name="discountName"
        type="text"
        placeholder="Discount Name"
        value={payload?.discountName}
        onChange={handleInputChange}
        label={"Discount Name"}
      />
      <label
        htmlFor={"percentageOff"}
        className="block mb-2 text-grey text-[16px] manrope capitalize"
      >
        <div className="flex justify-between items-center">Percentage off</div>
      </label>

      <select
        id="percentageOff"
        className={
          "p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        }
        value={payload?.percentageOff}
        onChange={(e) => {
          setPayload({ ...payload, percentageOff: e?.target?.value });
        }}
      >
        <option value="" disabled>
          Choose a discount
        </option>
        {Array.from({ length: 100 }, (_, i) => i + 1).map((value) => (
          <option key={value} value={value}>
            {value}%
          </option>
        ))}
      </select>
      <div className="flex gap-[10px] mb-2 text-grey text-[16px] manrope capitalize">
        <div className="w-6/12">Start Date</div>
        <div className="w-6/12">End Date</div>
      </div>
      <RangePicker
        showTime
        className={
          "p-3 mb-3 text-[16px] bg-white w-full border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        }
        value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
        onCalendarChange={(dates, dateStrings) => {
          if (dates && dates[0] && dates[1]) {
            const startDate = dates[0].format("YYYY-MM-DD");
            const endDate = dates[1].format("YYYY-MM-DD");

            setStartDate(startDate);
            setEndDate(endDate);

            setPayload({ ...payload, startDate, endDate });
          }
        }}
      />

      <div className="flex gap-[10px]">
        <Input
          name="minimumOrderAmount"
          type="text"
          placeholder=""
          value={formatNumberWithCommas(payload?.minimumOrderAmount)}
          onChange={handleInputChange}
          label={"Minimum Order Amount"}
        />
        <Input
          name="maxDiscountAmount"
          type="text"
          placeholder=""
          value={formatNumberWithCommas(payload?.maxDiscountAmount)}
          onChange={handleInputChange}
          label={"Max Discount Amount"}
        />
      </div>
      <Textarea
        label="Description"
        name={"description"}
        value={payload?.description}
        placeholder={"Description"}
        onChange={handleInputChange}
      />
      <Button
        onClick={handleSubmit}
        isLoading={isLoading}
        disabled={Object.entries(payload).some(([key, value]) => !value)}
        label={"Complete"}
      />
    </motion.div>
  );
};

export default OrderDiscountForm;
